import React, { useEffect, useState } from 'react';
import {
  createRecurringDef,
  getApiErrorMessage,
  listRecurringDefs,
  recurringDefAction,
} from '../../services/tasksAPI';
import type { RecurringTaskDef } from '@/shared/types/taskQueue.types';
import './TaskQueue.css';

const RecurringDefsPage: React.FC = () => {
  const [defs, setDefs] = useState<RecurringTaskDef[]>([]);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [cadence, setCadence] = useState<'daily' | 'weekly' | 'monthly'>('daily');

  const load = (): void => {
    listRecurringDefs()
      .then(setDefs)
      .catch((err: unknown) => setMessage(getApiErrorMessage(err)));
  };

  useEffect(load, []);

  const create = async (): Promise<void> => {
    if (!title.trim()) return;
    try {
      await createRecurringDef({ title: title.trim(), cadence });
      setTitle('');
      load();
    } catch (err: unknown) {
      setMessage(getApiErrorMessage(err));
    }
  };

  const act = async (id: string, action: 'approve' | 'pause' | 'resume' | 'archive'): Promise<void> => {
    try {
      await recurringDefAction(id, action);
      load();
    } catch (err: unknown) {
      setMessage(getApiErrorMessage(err));
    }
  };

  return (
    <div className="task-queue-page">
      <h1>Recurring tasks</h1>
      {message ? <p className="task-message">{message}</p> : null}
      <div className="task-form">
        <label>
          Title
          <input value={title} onChange={(e) => setTitle(e.target.value)} />
        </label>
        <label>
          Cadence
          <select value={cadence} onChange={(e) => setCadence(e.target.value as typeof cadence)}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </label>
        <button type="button" className="primary" onClick={() => void create()}>
          Create definition
        </button>
      </div>
      <table className="task-admin-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Cadence</th>
            <th>Active</th>
            <th>Approved</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {defs.map((d) => (
            <tr key={d.id}>
              <td>{d.title}</td>
              <td>{d.cadence}</td>
              <td>{d.active ? 'yes' : 'no'}</td>
              <td>{d.approvedAt ? 'yes' : 'no'}</td>
              <td>
                {!d.approvedAt ? (
                  <button type="button" onClick={() => void act(d.id, 'approve')}>
                    Approve
                  </button>
                ) : null}
                {d.approvedAt && d.active ? (
                  <button type="button" onClick={() => void act(d.id, 'pause')}>
                    Pause
                  </button>
                ) : null}
                {d.approvedAt && !d.active ? (
                  <button type="button" onClick={() => void act(d.id, 'resume')}>
                    Resume
                  </button>
                ) : null}
                <button type="button" onClick={() => void act(d.id, 'archive')}>
                  Archive
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecurringDefsPage;
